import type {
  EntityType,
  ExtractionPattern,
  MergeStrategy,
  PropertySchema,
  RelationType,
  Schema,
} from '@/services/api/schemas'

/** Alias kept for parity with the original module naming. */
export type SchemaPattern = ExtractionPattern

/** Property primitive types offered in the property editor dropdown. */
export const PROPERTY_TYPES = [
  'STRING',
  'INTEGER',
  'FLOAT',
  'BOOLEAN',
  'DATE',
  'ZONED_DATETIME',
] as const

/** A schema name grouped with all of its versions (newest first). */
export interface SchemaGroup {
  name: string
  versions: Schema[]
}

/** Draft form state for creating/editing an entity type. */
export interface EntityFormState {
  label: string
  description: string
  properties: PropertySchema[]
  merge_strategy: MergeStrategy
  trackable: boolean
  timeline_exclude: string[]
  display_label: Record<string, string>
}

/** Draft form state for creating/editing a relation type. */
export interface RelationFormState {
  label: string
  description: string
  properties: PropertySchema[]
  timeline_exclude: string[]
}

/** Draft form state for creating/editing an extraction pattern. */
export interface PatternFormState {
  source_type: string
  relationship_type: string
  target_type: string
  description: string
}

export const EMPTY_ENTITY_FORM: EntityFormState = {
  label: '',
  description: '',
  properties: [],
  merge_strategy: 'any',
  trackable: false,
  timeline_exclude: [],
  display_label: {},
}

export const EMPTY_RELATION_FORM: RelationFormState = {
  label: '',
  description: '',
  properties: [],
  timeline_exclude: [],
}

export const EMPTY_PATTERN_FORM: PatternFormState = {
  source_type: '',
  relationship_type: '',
  target_type: '',
  description: '',
}

export type { EntityType, PropertySchema, RelationType, Schema }
